import React from 'react'
import { CheckedSVG } from '../../../../../components/IconSvg'
import { useParams } from 'react-router-dom'
import { numberDisplayHandler } from '../../../../../components/helper'
import { useTranslation } from 'react-i18next'

type Props = { type: string }
type Steps = { step: number }

const RegisterSteps = ({ type = "package-free" }: Props) => {
    const params = useParams();
    const { t, i18n } = useTranslation()


    const stepsCreation = () => {
        if (type === "package-free") {
            return [{ step: 1 }, { step: 2 }, { step: 3 }]
        } else {
            return [{ step: 1 }, { step: 2 }, { step: 3 }, { step: 4 }]
        }
    }

    const stepClassNameCreation = (step: number) => {
        if (type === "package-free") {

            return {
                isActive: (params.step === 'userInfo' && step === 1) || (params.step === 'websiteAddress' && step === 2) || (params.step === 'finish' && step === 3),
                isPassed: ((params.step === 'websiteAddress' && step === 1) || (params.step === 'finish' && step < 3))
            }
        } else {
            return {
                isActive: (params.step === 'userInfo' && step === 1) || (params.step === 'websiteAddress' && step === 2) || (params.step === 'package' && step === 3) || (params.step === 'payBack' && step === 4),
                isPassed: (params.step === 'websiteAddress' && step === 1) || (params.step === 'package' && step <= 2) || (params.step === 'payBack' && step < 4)
            }
        }
    }

    return (<div className={`register-wizard-steps-container ${type !== "package-free" ? 'mony-package' : ''}`}>
        {stepsCreation().map((s: Steps, idx: number) => {

            return (<> <span className={`${stepClassNameCreation(s.step).isActive ? 'active' : ''} 
            ${stepClassNameCreation(s.step).isPassed ? 'passed' : ''}`} key={idx}>{stepClassNameCreation(s.step).isPassed ? <CheckedSVG /> : numberDisplayHandler(s.step, i18n)}</span>
                {idx < (stepsCreation().length - 1) && <i className={`${stepClassNameCreation(s.step).isPassed ? 'passed' : ''}`}></i>}</>)
        })}
    </div>)
}
export default RegisterSteps